import DetalleJuicio from '../../moleculas/DetalleJuicio/DetalleJuicio'
function DetalleJuicioContainer() {
  return (
    <div> 
      <DetalleJuicio/>
    </div>
  )
}

export default DetalleJuicioContainer

